import React from "react";
import Link from "gatsby-link";

export default function PostTags({ list = [] }) {
  return (
    <ul className="tag-list">
      {list.map(tag => (
        <li key={tag}>
          <Link to={`/blog/etiquetas/${tag}`}>{tag}</Link>
        </li>
      ))}
    </ul>
  );
}


// WEBPACK FOOTER //
// ./src/components/Linking/postTags.js